<ng-content></ng-content>
<div class="calendar-container">
  <div class="flex-fill" #calendarContainer>
    <cam-calendar-widget
      #calendarRef
      [date]="this.currentDate"
      [modes]="this.modes"
      [mode]="'week'"
      [resources]="this.resources() ?? []"
      [events]="this.events()"
      [timeRangesFeature]="this.timeRangesFeature"
      [timeRanges]="this.timeRanges()"
      [eventRenderer]="this.eventRenderer"
      [externalEventSourceFeature]="this.externalEventSourceFeature()"
      (beforeDragResizeEnd)="this.onBeforeDragMoveEnd($event)"
      (beforeDragMoveEnd)="this.onBeforeDragMoveEnd($event)"
    ></cam-calendar-widget>
  </div>
</div>
